import React from "react";
import { connect } from "react-redux";

import { logout } from "../../data/actions/authenticationActions";

const LogoutPage: React.FunctionComponent<{ logout: () => void }> = ({
  logout,
}) => {
  logout();

  return <p>Logging out...</p>;
};

function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch(logout()),
  };
}

const component = connect(null, mapDispatchToProps)(LogoutPage);
export default component;
